import React, { useState } from "react";
import "./ListCard.scss";
import PropTypes from "prop-types";
import { convert, showError, showSuccess } from "Services/functions";
import {
  getCustomIcon,
  getListOfUsers,
  getNumberOfUsers,
} from "Services/newsletterFunctions";
import { Tooltip } from "primereact/tooltip";
import Modal from "Components/Modal/Modal";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { connect } from "react-redux";
import { fetchDeleteUp } from "Services/api";

const ListCard = (props) => {
  // const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const customIcon = getCustomIcon(props.data);
  // const editList = () => {
  //   console.log(props.data);
  // };
  const deleteList = async () => {
    if (props.data.newsletters?.length > 0) {
      return;
    }

    const response = await fetchDeleteUp(`/list_of_contacts/${props.data.id}`);
    if (response.error) {
      showError("Une erreur est survenue");
    } else {
      props.setAllListOfContacts(
        props.allListOfContacts.filter(
          (element) => element.id !== props.data.id
        )
      );
      showSuccess("Votre liste de contacts a bien été supprimée");
    }
  };
  return (
    <div
      className="mylists__card"
      onClick={() => props.select && props.loadList(props.data)}
    >
      <div className="mylists__card__left">
        <div className="mylists__card__left__title">{props.data.title}</div>
        <div className="mylists__card__left__date">
          {"Créée le " + convert(props.data.createdAt)}
        </div>
        <div className="mylists__card__left__members">
          Contacts : {getNumberOfUsers(props.data)}
        </div>
        {customIcon && <img src={customIcon} alt="" className="customIcon" />}
      </div>
      {!props.select && (
        <div className="mylists__card__right">
          <Tooltip target=".mylists__card__right__icon" />
          <div
            className="mylists__card__right__icon pi pi-download"
            data-pr-tooltip="Charger la liste"
            data-pr-position="bottom"
            onClick={() => props.loadList(props.data)}
          ></div>
          {/* <div
            className="mylists__card__right__icon pi pi-pencil"
            data-pr-tooltip="Modifier la liste"
            data-pr-position="bottom"
            onClick={() => {
              setIsEditing(true);
            }}
          ></div> */}
          <div
            className="mylists__card__right__icon pi pi-trash"
            data-pr-tooltip="Supprimer la liste"
            data-pr-position="bottom"
            onClick={() => {
              setIsDeleting(true);
            }}
          ></div>
          {props.data.codeEtapes.length === 0 && (
            <div
              className="mylists__card__right__icon pi pi-users"
              data-pr-tooltip="Liste des contacts"
              data-pr-position="bottom"
              onClick={() => {
                setShowUsers(true);
              }}
            ></div>
          )}
        </div>
      )}
      {/* {isEditing && (
        <Modal
          visible={isEditing}
          setVisible={setIsEditing}
          header="Modifier la liste"
          className="modal newsletters"
        >
          <BtnBleu
            btnTexte="Modifier"
            btnAction={() => {
              setIsDeleting(false);
              editList();
            }}
          ></BtnBleu>
        </Modal>
      )} */}
      {isDeleting && (
        <Modal
          visible={isDeleting}
          setVisible={setIsDeleting}
          header="Supprimer la liste"
          className="modal newsletters deleteList"
        >
          <span>Êtes vous sûr(e) de vouloir supprimer cette liste ?</span>
          <div className="buttons">
            <BtnBlanc
              btnTexte="Oui"
              btnAction={() => {
                setIsDeleting(false);
                deleteList();
              }}
            ></BtnBlanc>
            <BtnBleu btnTexte="Non"></BtnBleu>
          </div>
        </Modal>
      )}
      {showUsers && (
        <Modal
          visible={showUsers}
          setVisible={setShowUsers}
          header="Liste des contacts"
          className="modal newsletters"
        >
          <ul className="showUsersList" style={{ listStyle: "disc" }}>
            {getListOfUsers(props.data).map((user, key) => (
              <li key={key}>
                <span style={{ marginRight: "0.5rem" }}>{user.firstname}</span>
                <span>{user.surname}</span>
              </li>
            ))}
          </ul>
        </Modal>
      )}
    </div>
  );
};

ListCard.propTypes = {
  data: PropTypes.object,
  loadList: PropTypes.func,
  select: PropTypes.bool,
  auth: PropTypes.object,
  allListOfContacts: PropTypes.array,
  setAllListOfContacts: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(ListCard);
